
import {
  defineComponent,
  useRoute,
  ref,
  computed,
  watch,
} from '@nuxtjs/composition-api'
import NavigationSearchForm from '~/components/navigation/NavigationSearchForm.vue'
import { getCountryCode } from '~/assets/ts/Locale'
import { AppointmentLink } from '~/assets/ts/appointment/AppointmentLink'

export default defineComponent({
  components: { NavigationSearchForm },
  emits: ['mobile-navi'],
  setup(_props, { emit }) {
    const country: string = getCountryCode()

    const visibleNavigation = ref('')

    const appointmentLink = new AppointmentLink().getAppointmentOverview()

    const navData: { [key: string]: any } = {
      engagement: {
        all: 'engagementRings',
        bestseller: 'engagementRingsBestseller',
        fastDelivery: 'engagementRingsFastDelivery',
        budgetLow: 'engagementRingsBudgetLow',
        budgetMedium: 'engagementRingsBudgetMedium',
        budgetHigh: 'engagementRingsBudgetHigh',
        stonesize1: 'engagementRings025Carat',
        stonesize2: 'engagementRings050Carat',
        stonesize3: 'engagementRings100Carat',
        //
        gold: 'engagementRingsGold',
        rosegold: 'engagementRingsRosegold',
        platinum: 'engagementRingsPlatinum',
        signature: 'engagementRingsSignature',
        whitegold: 'engagementRingsWhitegold',
        redgold: 'engagementRingsRedgold',
        //
        design: [
          'engagementRingsClassic',
          'engagementRingsFancy',
          'engagementRingsDiamonds',
          'engagementRingsVintage',
          'engagementRingsModern',
        ],
        //
        ringsets: 'weddingRingsRingSets',
        configurator: 'configurator',
        configuratorHash: 'A-1488-9',
      },
      wedding: {
        all: 'weddingRings',
        bestseller: 'weddingRingsBestseller',
        budgetLow: 'weddingRingsBudgetLow',
        budgetMedium: 'weddingRingsBudgetMedium',
        budgetHigh: 'weddingRingsBudgetHigh',
        genderFemale: 'weddingRingsWomen',
        genderMale: 'weddingRingsMen',
        genderBoth: 'weddingRings',
        //
        gold: 'weddingRingsGold',
        rosegold: 'weddingRingsRosegold',
        platinum: 'weddingRingsPlatinum',
        signature: 'weddingRingsSignature',
        whitegold: 'weddingRingsWhitegold',
        multi: 'weddingRingsTwoColors',
        //
        design: [
          'weddingRingsClassic',
          'weddingRingsModern',
          'weddingRingsDiamonds',
          'weddingRingsFancy',
          'weddingRingsFinishes',
        ],
        //
        ringsets: 'weddingRingsRingSets',
        configurator: 'configurator',
        configuratorHash: 'A-1465-6',
      },
      eternity: {
        all: 'memoireRings',
        bestseller: 'memoireRingsBestseller',
        budgetLow: 'memoireRingsBudgetLow',
        budgetMedium: 'memoireRingsBudgetMedium',
        budgetHigh: 'memoireRingsBudgetHigh',
        //
        gold: 'memoireRingsGold',
        rosegold: 'memoireRingsRosegold',
        platinum: 'memoireRingsPlatinum',
        signature: 'memoireRingsSignature',
        whitegold: 'memoireRingsWhite',
        redgold: 'memoireRingsRedgold',
        //
        design: [
          'memoireRingsFullSizeMemoires', // Voll ausgefasst
          'memoireRingsGrowingMemoires', // wachsend
          'memoireRingsHalfSetMemories', // Halb ausgefasst
          'memoireRingsRingsets', // Ringsets
          'memoireRingsColored', // Farbige Steine
        ],
        //
        ringsets: 'memoireRingsRingsets',
        configurator: 'configurator',
        configuratorHash: 'A-2045-309',
      },
      jewelry: {
        all: 'diamondJewelry',
        bestseller: 'diamondJewelryBestseller',
        budgetLow: 'diamondJewelryBudgetLow',
        budgetMedium: 'diamondJewelryBudgetMedium',
        budgetHigh: 'diamondJewelryBudgetHigh',
        //
        gold: 'diamondJewelryGold',
        rosegold: 'diamondJewelryRosegold',
        platinum: 'diamondJewelryPlatinum',
        signature: 'diamondJewelrySignature',
        whitegold: 'diamondJewelryWhitegold',
        redgold: 'diamondJewelryRedgold',
        //
        design: [
          'diamondJewelry050Carat',
          'diamondJewelryEarrings',
          'diamondJewelryColliers',
          'diamondJewelrySets',
          'diamondJewelryCollectionRings',
        ],
        //
        ringsets: 'weddingRingsRingSets',
        configurator: 'configurator',
        configuratorHash: 'A-1147-24',
      },
    }

    const navActive = computed(() => {
      if (visibleNavigation.value) {
        const navCategory: string = visibleNavigation.value
          .replace('desktop', '')
          .toLowerCase()
        return navData[navCategory]
      }
    })

    const toogleNavigation = (navNode: string) => {
      visibleNavigation.value =
        visibleNavigation.value !== navNode ? navNode : ''

      if (visibleNavigation.value === 'mobile') {
        emit('mobile-navi', true)
      } else {
        emit('mobile-navi', false)
      }
    }

    const hideNavi = () => {
      visibleNavigation.value = ''
      emit('mobile-navi', false)
    }

    const route = useRoute()

    const watchPageSwitch = watch(
      () => route.value.path,
      () => {
        if (visibleNavigation.value !== '') {
          hideNavi()
        }
      }
    )

    /**
     * Search form
     */

    const searchForm = ref(false)

    return {
      country,
      navData,
      navActive,
      visibleNavigation,
      toogleNavigation,
      hideNavi,
      appointmentLink,
      watchPageSwitch,
      searchForm,
    }
  },
})
